import type { IRegDataWarning } from "../../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";
import { hasDrFlagMismatchWarning, hasHazardousMismatchWarning } from "./regDataAlignmentDisplay";

export function HazardousMismatchAlert({ warnings }: { warnings: IRegDataWarning[] }) {
    if (!hasHazardousMismatchWarning(warnings)) return null;
    return (
        <div className="small text-warning mt-1">
            Code matches; hazardous flag differs. Use the arrow to apply the template hazardous flag.
        </div>
    );
}

export function DrFlagMismatchAlert({ warnings }: { warnings: IRegDataWarning[] }) {
    if (!hasDrFlagMismatchWarning(warnings)) return null;
    return (
        <div className="small text-warning mt-1">
            Code matches; receipt/removal membership flags differ. Use the arrow to apply template flags.
        </div>
    );
}
